import { render, staticRenderFns } from "./create-or-edit-legal-entity-action.vue?vue&type=template&id=4ae61944"
import script from "./create-or-edit-legal-entity-action.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-legal-entity-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports